import React from 'react';
import { Flex, Title, ThemeIcon, Text } from '@mantine/core';

export default function PageTitle({
  title,
  subtitle,
  icon,
  iconColor,
  actions,
  style = { marginBottom: '1.5em' },
}) {
  return (
    <div style={{ ...style }}>
      <Flex align="center" gap="xs">
        <Title order={3}>{title}</Title>
        {actions}
      </Flex>
      {(subtitle || icon) && (
        <Flex align="center">
          {icon && (
            <ThemeIcon
              radius="xl"
              mr="xs"
              size="sm"
              variant="light"
              color={iconColor}
            >
              {icon}
            </ThemeIcon>
          )}
          <Text size="sm">{subtitle}</Text>
        </Flex>
      )}
    </div>
  );
}
